import React, { useEffect, useState, useRef } from 'react';
import { BookOpenIcon, CheckCircle2Icon, FileTextIcon, LockIcon, MapIcon, ShieldCheckIcon, SparklesIcon, StarIcon, ZapIcon } from 'lucide-react';
const launchTestimonials = [{
  quote: 'Antes improvisaba cada sesión con ventosas porque nunca encontré algo realmente profesional en español. Este sistema cambió todo. Mis clientas ahora ven resultados y vuelven.',
  name: 'Valentina M.',
  role: 'Esteticista · Buenos Aires'
}, {
  quote: 'Lo que más me sorprendió fue el protocolo de cuello y mandíbula. Mi clienta me dijo que se veía 5 años más joven después de la primera sesión. Ya reservó las próximas cuatro.',
  name: 'Carolina R.',
  role: 'Cosmetóloga · Ciudad de México'
}, {
  quote: 'Subí mis precios un 40% el mes que empecé a usar los protocolos del Tomo IV. Mis clientas sienten que reciben algo premium. Porque es premium.',
  name: 'Daniela S.',
  role: 'Esteticista Independiente · Madrid'
}];
export function Hero() {
  const ctaAnchorRef = useRef<HTMLDivElement>(null);
  const [showStickyCta, setShowStickyCta] = useState(true);
  useEffect(() => {
    const ctaAnchor = ctaAnchorRef.current;
    if (!ctaAnchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      setShowStickyCta(!entry.isIntersecting && entry.boundingClientRect.top > 0);
    }, {
      threshold: 0.15
    });
    observer.observe(ctaAnchor);
    return () => observer.disconnect();
  }, []);
  return <>
      <header className="beauty-header w-full bg-cream px-5 pt-5 sm:px-7" data-id="element-56">
        <div className="mx-auto flex max-w-6xl items-center justify-between border-b border-brand-100 pb-4" data-id="element-57">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-900 sm:text-xs" data-id="element-58">
            MAESTRÍA EN VENTOSAS ESTÉTICAS™
          </p>
          <span className="hidden text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-600 sm:block" data-id="element-59">
            Sistema profesional en español
          </span>
        </div>
      </header>

      <main data-id="element-60">
        <section className="beauty-hero w-full bg-cream px-5 pb-14 pt-5 sm:px-7 md:pb-20 md:pt-8" data-id="element-61">
          <div className="mx-auto grid max-w-6xl gap-9 lg:min-h-[610px] lg:grid-cols-[0.95fr_1.05fr] lg:items-center" data-id="element-62">
            <div className="relative z-10 text-center lg:py-12 lg:text-left" data-id="element-63">
              <p className="mb-8 hidden text-xs font-medium tracking-[0.28em] text-brand-600 lg:block" data-id="element-64">
                01
              </p>

              <div className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.18em] text-brand-700 sm:text-[11px]" data-id="element-65">
                <SparklesIcon className="h-3.5 w-3.5 text-accent" aria-hidden="true" data-id="element-66" />
                MAESTRÍA EN VENTOSAS ESTÉTICAS™
              </div>

              <h1 className="mt-5 max-w-2xl font-semibold tracking-tight text-brand-900 sm:text-6xl lg:text-[4.3rem] text-[28px]" data-id="element-67">
                El Sistema de Ventosas Estéticas que logra cambios a tus
                Clientas en la Primera Sesión (y Vuelven a Pagarlo)
              </h1>

              <p className="mx-auto mt-6 max-w-xl text-sm leading-relaxed text-brand-700 sm:text-base lg:mx-0" data-id="element-68">
                6 tomos. 360 páginas. Todos tus protocolos resueltos — rostro,
                cuello, cuerpo y bienestar.
              </p>

              <div className="mt-7 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-brand-800 lg:justify-start" data-id="element-69">
                <span className="flex items-center gap-1.5" data-id="element-70">
                  <BookOpenIcon className="h-4 w-4 text-accent" data-id="element-71" />6 Tomos
                </span>
                <span className="flex items-center gap-1.5" data-id="element-72">
                  <SparklesIcon className="h-4 w-4 text-accent" data-id="element-73" />5 Bonos
                </span>
                <span className="flex items-center gap-1.5" data-id="element-74">
                  <FileTextIcon className="h-4 w-4 text-accent" data-id="element-75" />
                  360+ páginas
                </span>
                <span className="flex items-center gap-1.5" data-id="element-76">
                  <MapIcon className="h-4 w-4 text-accent" data-id="element-77" />
                  Mapas de protocolos
                </span>
                <span className="flex items-center gap-1.5" data-id="element-78">
                  <CheckCircle2Icon className="h-4 w-4 text-accent" data-id="element-79" />
                  Todos los niveles
                </span>
              </div>

              <div ref={ctaAnchorRef} className="mx-auto mt-8 w-full max-w-xl lg:mx-0" data-id="element-80">
                <a href="#pricing" className="flex w-full items-center justify-center rounded-full bg-brand-600 px-6 py-4 text-center text-xs font-bold uppercase tracking-[0.1em] text-white shadow-lg transition-colors hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-500/30" data-id="element-81">
                  QUIERO MI MAESTRÍA AHORA
                </a>
              </div>

              <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-[10px] font-medium text-brand-700 lg:justify-start" data-id="element-82">
                <span className="flex items-center gap-1" data-id="element-83">
                  <LockIcon className="h-3.5 w-3.5" data-id="element-84" />
                  Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-85">
                  <ZapIcon className="h-3.5 w-3.5" data-id="element-86" />
                  Acceso inmediato
                </span>
                <span className="flex items-center gap-1" data-id="element-87">
                  <ShieldCheckIcon className="h-3.5 w-3.5" data-id="element-88" />
                  Garantía de 7 días
                </span>
                <span data-id="element-89">100% PDF</span>
              </div>
            </div>

            <div className="beauty-product-hero relative mx-auto w-full max-w-xl lg:max-w-none" data-id="element-90">
              <span className="beauty-stage-number" aria-hidden="true" data-id="element-91">
                06
              </span>
              <img src="https://cdn.magicpatterns.com/uploads/jgck9dydKeZS11VQTUyGbH/hf_20260713_182801_09462df3-a1fa-4ae0-ae6d-8a5a53a2d815.png" alt="Maestría en Ventosas Estéticas con seis tomos, guía de acción y materiales de cabina" className="beauty-product-image relative z-10 w-full object-cover" data-id="element-92" />
              <aside className="beauty-tome-card absolute bottom-5 left-5 z-20 w-[calc(100%-2.5rem)] p-4 sm:bottom-7 sm:left-7 sm:w-[calc(100%-3.5rem)]" aria-label="Vista previa de los seis tomos" data-id="element-93">
                <div className="flex items-center justify-between" data-id="element-94">
                  <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-brand-700" data-id="element-95">
                    Sistema completo
                  </span>
                  <span className="text-[10px] font-bold uppercase tracking-[0.12em] text-accent" data-id="element-96">
                    6 tomos
                  </span>
                </div>
                <p className="mt-2 text-[11px] leading-relaxed text-brand-700" data-id="element-97">
                  Protocolos claros para aplicar desde la primera sesión
                </p>
              </aside>
            </div>
          </div>
        </section>

        <section className="border-y border-brand-100 bg-white px-5 py-6 sm:px-7" aria-label="Características del sistema" data-id="element-98">
          <div className="mx-auto grid max-w-6xl grid-cols-2 gap-y-5 text-center md:grid-cols-4" data-id="element-99">
            {[['🌎', 'Para todo el mundo', 'hispanohablante'], ['📗', '6 Tomos + 5 Bonos', 'incluidos'], ['📄', '360+ páginas', 'de protocolos'], ['⭐', 'Sistema profesional', 'completo']].map(([icon, value, label]) => <div key={value} className="border-brand-100 px-3 even:border-l md:border-l" data-id="element-100">
                <p className="text-xs font-bold text-brand-900 sm:text-sm" data-id="element-101">
                  {icon} {value}
                </p>
                <p className="mt-1 text-[9px] font-semibold uppercase tracking-[0.13em] text-brand-600" data-id="element-102">
                  {label}
                </p>
              </div>)}
          </div>
        </section>

        <section className="bg-white px-5 py-16 sm:px-7 md:py-24" data-id="element-103">
          <div className="mx-auto max-w-6xl" data-id="element-104">
            <div className="mb-10 text-center" data-id="element-105">
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-600" data-id="element-106">
                Testimonios de lanzamiento
              </p>
              <h2 className="mt-3 text-4xl font-semibold text-brand-900 md:text-5xl" data-id="element-107">
                Lo que cambia cuando dejás de improvisar
              </h2>
            </div>
            <div className="grid gap-4 md:grid-cols-3" data-id="element-108">
              {launchTestimonials.map(testimonial => <article key={testimonial.name} className="rounded-2xl border border-brand-100 bg-cream p-6" data-id="element-109">
                  <div className="flex gap-0.5 text-accent" aria-label="5 de 5 estrellas" data-id="element-110">
                    {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-111" />)}
                  </div>
                  <blockquote className="mt-4 text-sm leading-relaxed text-brand-800" data-id="element-112">
                    “{testimonial.quote}”
                  </blockquote>
                  <footer className="mt-5 border-t border-brand-100 pt-4" data-id="element-113">
                    <p className="text-sm font-bold text-brand-900" data-id="element-114">
                      {testimonial.name}
                    </p>
                    <p className="mt-0.5 text-[10px] uppercase tracking-[0.1em] text-brand-600" data-id="element-115">
                      {testimonial.role}
                    </p>
                  </footer>
                </article>)}
            </div>
            <p className="mt-5 text-center text-xs text-brand-600" data-id="element-116">
              Testimonios de lanzamiento. Se reemplazarán por opiniones
              verificadas de compradoras.
            </p>
          </div>
        </section>
      </main>

      <div className={`pointer-events-none fixed inset-x-0 bottom-0 z-50 px-4 pb-[calc(1rem+env(safe-area-inset-bottom))] pt-3 transition-[opacity,transform] duration-300 ease-out motion-reduce:transition-none ${showStickyCta ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'}`} aria-hidden={!showStickyCta} data-id="element-117">
        <a href="https://cupping-estetico.impultienda.ar/checkout" tabIndex={showStickyCta ? 0 : -1} className="pointer-events-auto mx-auto flex w-full max-w-md items-center justify-center rounded-full bg-brand-600 px-5 py-4 text-center text-xs font-bold uppercase tracking-[0.08em] text-white shadow-xl transition-colors hover:bg-brand-700 focus:outline-none focus:ring-4 focus:ring-brand-500/30" data-id="element-118">
          QUIERO MI MAESTRÍA AHORA
        </a>
      </div>
    </>;
}